jQuery(function ($) {
    var mapStyles = [
        {
            "featureType": "all",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#e5c163"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#c4c4c4"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#e5c163"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 21
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#e5c163"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#e5c163"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#575757"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#2c2c2c"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#999999"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ];

    /* -----------------------------
    * Navigation
     ---------------------------- */
    let openMenuToggleClass = 'open';
    let bodyNavOpenClass = 'nav-open';
    $('.js-menu-toggle').click(function (e) {
        e.preventDefault();
        let target = $(this).data('target');

        if ($(this).hasClass(openMenuToggleClass)) {
            // Hide
            $(this).removeClass(openMenuToggleClass);
            $(target).removeClass(openMenuToggleClass);
            $('body').removeClass(bodyNavOpenClass);
        } else {
            // Reveal
            $(this).addClass(openMenuToggleClass);
            $(target).addClass(openMenuToggleClass);
            $('body').addClass(bodyNavOpenClass);
        }
    });

    /* -----------------------------
    * Basket Preview
     ---------------------------- */
    let $basketPreview = $('.js-header-basket-preview');

    $('.js-basket-preview-toggle').click(function(e) {
        if ($(window).width() >= 992) {
            e.preventDefault();
            $basketPreview.fadeToggle();
        }
    });

    $(document).on("click", ".js-header-basket-preview-remove", function(e) {
        e.preventDefault();

        let productId = $(this).data('product-id');
        jQuery.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            data: {
                updates: {
                    [productId]: 0
                }
            }
        });

        $(this).parent('.js-basket-preview-item').slideUp();

        setTimeout(function() {
            updateCartPreview();
        }, 500);
    });

    /* -----------------------------
    * Custom Quantity
     ---------------------------- */
    $('.js-quantity-minus').click(function (e) {
        e.preventDefault();
        let input = $(this).siblings('input');

        let currVal = parseInt($(input).val());
        let minVal = parseInt($(input).attr('min'));

        if (minVal < currVal) {
            $(input).val(currVal - 1);
            $(input).change();
        }
    });

    $('.js-quantity-plus').click(function (e) {
        e.preventDefault();

        let input = $(this).siblings('input');

        let currVal = parseInt($(input).val());
        let maxVal = parseInt($(input).attr('max'));

        if (maxVal > currVal) {
            $(input).val(currVal + 1);
            $(input).change();
        }
    });

    /* -----------------------------
    * Featured Product Slider
     ---------------------------- */
    let $featuredProductSlider = $('.js-featured-product-slider');
    console.log($featuredProductSlider.length);
    if ($featuredProductSlider.length > 0) {
      console.log("TEST");
        let swipeIcon = $featuredProductSlider.find('.js-swipe-icon');

        $featuredProductSlider.slick({
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 992,
                    settings: "unslick"
                }
            ]
        });

        $featuredProductSlider.on('afterChange', function (event, slick) {
            $(swipeIcon).fadeOut();
        });
    }

    /* -----------------------------
    * Product Page Image Sliders
     ---------------------------- */
    let $productPageImageSliderMain = $('.js-product-page-main-slider');
    let $productPageImageSliderThumb = $('.js-product-page-thumb-slider');
    let $productPageStaticImage = $('.js-product-static-image');

    if ($productPageImageSliderMain.length > 0) {
        // Init event to set height for absolute positioned sliders
        $productPageImageSliderThumb.on('init', function (event, slick) {
            let $sliderWrapper = $('.js-product-page-sliders');
            let sliderHeight = $sliderWrapper.height();

            $('.js-product-page').css('min-height', sliderHeight + 200);
        });

        $productPageImageSliderMain.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $productPageImageSliderThumb,
            arrows: false,
            swipe: false
        });

        $productPageImageSliderThumb.slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            asNavFor: $productPageImageSliderMain,
            mobileFirst: true,
            arrows: true,
            appendArrows: $($productPageImageSliderThumb).siblings('.js-product-page-thumb-slider-nav'),
            prevArrow: '',
            nextArrow: '<button type="button" class="product-page__image-slider__slick-arrow"><svg width="21px" height="20px" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="shop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="5-shop-detail" transform="translate(-1375.000000, -765.000000)" fill="#FFFFFF" fill-rule="nonzero"><g id="images" transform="translate(754.000000, 272.000000)"><g id="Group-2" transform="translate(0.000000, 460.000000)"><g id="scroll" transform="translate(604.000000, 0.000000)"><g id="arrow" transform="translate(27.500000, 43.000000) scale(-1, -1) rotate(90.000000) translate(-27.500000, -43.000000) translate(18.000000, 33.000000)"><path d="M19.4997304,10 C19.4874697,9.69125372 19.3596013,9.33439302 19.1464728,9.10936868 L11.3204573,0.90466 C10.8634962,0.366911854 9.98442601,0.37769454 9.47064809,0.862254722 C8.95691365,1.34681059 8.9147836,2.20492585 9.4319528,2.68594075 L15.1656222,8.70451055 L0.804335917,8.70451055 C0.08395119,8.70451055 -0.5,9.28456034 -0.5,10 C-0.5,10.7155009 0.08395119,11.295486 0.804335917,11.295486 L15.1656222,11.295486 L9.4319528,17.3140558 C8.91487056,17.7950663 8.95717452,18.6568176 9.47108287,19.1413691 C9.98486079,19.6259207 10.8764135,19.6280366 11.3207269,19.0953365 L19.1467424,10.8906494 C19.3847924,10.6394133 19.4965218,10.3463332 19.5,10 L19.4997304,10 Z" id="Path" transform="translate(9.500000, 10.000000) rotate(90.000000) translate(-9.500000, -10.000000) "></path></g></g></g></g></g></g></svg></button>',
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });

        $('.js-product-page-thumb-slider-slide').click(function (e) {
            e.preventDefault();
            let slideToGoTo = $(this).data('slide-index');
            $productPageImageSliderMain.slick('slickGoTo', slideToGoTo);
        });
    } else if($productPageStaticImage.length > 0) {
        let $sliderWrapper = $('.js-product-page-sliders');
        let $productPageSidebar = $('.js-product-page-sidebar');

        if($productPageSidebar.length > 0 && $(window).width() >= 992) {
            let sliderHeight = $productPageStaticImage.height();
            let currOffset = $productPageSidebar.offset().top - $productPageStaticImage.offset().top;
            let spacing = (sliderHeight - currOffset) + 40;

            $productPageSidebar.css('margin-top', spacing);
            console.log(currOffset);
        }
    }

    $('.js-product-image-enlarge').click(function(e) {
       e.preventDefault();

       let img = $(this).data('image-src');
       let $galleryModal = $('#product-gallery-modal');
        let $imgHolder = $('.js-product-gallery-modal-img-holder');

        $imgHolder.empty();
        let imgTag = '<img src="'+img+'" class="img-fluid"/>';
        $imgHolder.html(imgTag);

       $galleryModal.modal('show');
       console.log(img);
    });

    /* -----------------------------
    * Product Grid Filters
     ---------------------------- */
    let $productGridFilterSlider = $('.js-product-grid-filters');
    if ($productGridFilterSlider.length > 0) {
        let nav = $productGridFilterSlider.siblings('.js-product-grid-filters-nav');
        let initialSlideIndex = 0;
        let activeFilter = $productGridFilterSlider.find('.js-active-filter');
        if (activeFilter.length > 0) {
            let $activeSlide = $(activeFilter);
            initialSlideIndex = $activeSlide.data('slide-index');
        }

        $productGridFilterSlider.slick({
            arrows: true,
            appendArrows: $(nav),
            prevArrow: '<button type="button" class="product-grid__filters__arrow product-grid__filters__arrow--prev"><svg class="w-100" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="shop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="26.2-shop-index" transform="translate(-243.000000, -820.000000)" fill="currentColor" fill-rule="nonzero"><g id="filter" transform="translate(225.000000, 739.000000)"><g id="button" transform="translate(0.000000, 62.000000)"><g id="arrow" transform="translate(26.000000, 26.500000) scale(1, -1) rotate(90.000000) translate(-26.000000, -26.500000) translate(19.000000, 19.000000)"><path d="M14.4997978,7.5 C14.4906023,7.27250274 14.394701,7.00955275 14.2348546,6.84374534 L8.36534297,0.798170526 C8.02262218,0.40193505 7.36331951,0.409880187 6.97798607,0.766924532 C6.59268524,1.1239657 6.5610877,1.75626116 6.9489646,2.11069318 L11.2492166,6.54542883 L0.478251938,6.54542883 C-0.0620366075,6.54542883 -0.5,6.97283393 -0.5,7.5 C-0.5,8.02721122 -0.0620366075,8.4545686 0.478251938,8.4545686 L11.2492166,8.4545686 L6.9489646,12.8893042 C6.56115292,13.2437331 6.59288089,13.8787077 6.97831215,14.2357457 C7.36364559,14.5927837 8.03231014,14.5943428 8.36554514,14.2018269 L14.2350568,8.156268 C14.4135943,7.97114662 14.4973913,7.75519289 14.5,7.5 L14.4997978,7.5 Z" id="Path" transform="translate(7.000000, 7.500000) rotate(90.000000) translate(-7.000000, -7.500000) "></path></g></g></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="product-grid__filters__arrow product-grid__filters__arrow--next"><svg class="w-100" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="shop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="26.2-shop-index" transform="translate(-1390.000000, -820.000000)" fill="currentColor" fill-rule="nonzero"><g id="filter" transform="translate(225.000000, 739.000000)"><g id="button" transform="translate(1172.000000, 88.500000) scale(-1, 1) translate(-1172.000000, -88.500000) translate(1145.000000, 62.000000)"><g id="arrow" transform="translate(26.000000, 26.500000) scale(1, -1) rotate(90.000000) translate(-26.000000, -26.500000) translate(19.000000, 19.000000)"><path d="M14.4997978,7.5 C14.4906023,7.27250274 14.394701,7.00955275 14.2348546,6.84374534 L8.36534297,0.798170526 C8.02262218,0.40193505 7.36331951,0.409880187 6.97798607,0.766924532 C6.59268524,1.1239657 6.5610877,1.75626116 6.9489646,2.11069318 L11.2492166,6.54542883 L0.478251938,6.54542883 C-0.0620366075,6.54542883 -0.5,6.97283393 -0.5,7.5 C-0.5,8.02721122 -0.0620366075,8.4545686 0.478251938,8.4545686 L11.2492166,8.4545686 L6.9489646,12.8893042 C6.56115292,13.2437331 6.59288089,13.8787077 6.97831215,14.2357457 C7.36364559,14.5927837 8.03231014,14.5943428 8.36554514,14.2018269 L14.2350568,8.156268 C14.4135943,7.97114662 14.4973913,7.75519289 14.5,7.5 L14.4997978,7.5 Z" id="Path" transform="translate(7.000000, 7.500000) rotate(90.000000) translate(-7.000000, -7.500000) "></path></g></g></g></g></g></svg></button>',
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            initialSlide: initialSlideIndex,
            centerMode: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: "unslick"
                }
            ]
        });
    }

    $(document.body).on("click", ".js-switch-category-filter", function (e) {
        e.preventDefault();
        let getUrl = $(this).data('page-url') + '&view=data';
      	let setUrl = $(this).data('page-url');
        if (setUrl.indexOf("?") > 0) {
            setUrl = setUrl.substring(0, setUrl.indexOf("?"));
        }
        let $btn = $(this);
        let activeClass = 'product-grid__filters__filter--active';
        let collectionTitle = $(this).data('title');
      	let collectionDescription = $(this).data('description');

        $('.js-switch-category-filter').removeClass(activeClass);
        $('.js-collection-title').text(collectionTitle);
      	$('.js-collection-description').html(collectionDescription);

        $.ajax({
            url: getUrl,
            type: 'GET',
            beforeSend: function () {
                $btn.addClass(activeClass);
            },
            success: function (data) {
              	console.log(data);

                let $listingGrid = $('.js-listing-grid');

                // Add animate class to new items
                data = data.replace(/js-card-item/g, 'to-animate js-card-item');

                // Append new data
                $listingGrid.html(data);

                // Animate in new posts
                let timer = 0;
                let newPosts = $('.to-animate.js-card-item').not('.animated');
                console.log(newPosts);

                $(newPosts).each(function () {
                    let $currPost = $(this);
                    setTimeout(function () {
                        $currPost.addClass('animated');
                    }, timer);

                    timer = timer + 150;
                });

                history.pushState(null, null, setUrl);
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    /* -----------------------------
    * Homepage Masthead
     ---------------------------- */
    let $homepageMastheadBg = $('.js-homepage-masthead-bg-slider');
    let $homepageMastheadSliderNav = $('.js-homepage-masthead-slider-nav');

    if ($homepageMastheadBg.length > 0) {
        let $timer = $('.js-homepage-masthead-timer');
        let timerAnimateClass = 'animate';

        $homepageMastheadBg.slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: $homepageMastheadSliderNav
        });
        $homepageMastheadSliderNav.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $homepageMastheadBg,
            dots: false,
            arrows: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });

        $homepageMastheadBg.on('beforeChange', function (event, slick) {
            $timer.removeClass(timerAnimateClass);
        });

        $homepageMastheadBg.on('afterChange', function (event, slick) {
            $timer.addClass(timerAnimateClass);
        });
    }

    /* -----------------------------
    * Product Description Toggle
     ---------------------------- */
    let $productDescriptionCollapse = $('.js-product-description-collapse');
    let $productDescriptionToggle = $('.js-product-description-toggle');
    let productCollapseClass = 'collapsed';

    $productDescriptionToggle.click(function(e) {
       e.preventDefault();

       let target = $(this).attr('href');

       if($(this).hasClass(productCollapseClass)) {
           // Open
           $(target).slideDown();
           $(this).removeClass(productCollapseClass);
           $(this).html('<span>Read less</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"/></svg>');
       } else {
           // Close
           $(target).slideUp();
           $(this).addClass(productCollapseClass);
           $(this).html('<span>Read more</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"/></svg>');
       }
    });

    /* -----------------------------
    * Single Marker Map
     ---------------------------- */
    let $simpleMap = $('.js-single-marker-map');

    function initSimpleMap() {
        let markers = [];

        let currMap = document.getElementById('location-map');
        let mapMarker = $(currMap).data('marker');
        let mapLat = $(currMap).data('lat');
        let mapLng = $(currMap).data('lng');
        let zoom = $(currMap).data('zoom');

        let customMarker = {
            url: mapMarker,
            anchor: new google.maps.Point(31, 80)
        };

        let mapOptions = {
            zoom: zoom,
            scrollwheel: false,
            center: new google.maps.LatLng(mapLat, mapLng),
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            streetViewControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            styles: mapStyles
        };


        let map = new google.maps.Map(currMap, mapOptions);

        marker = new google.maps.Marker({
            map,
            animation: google.maps.Animation.DROP,
            position: new google.maps.LatLng(mapLat, mapLng),
            icon: customMarker
        });
    }

    if ($simpleMap.length > 0) {
        google.maps.event.addDomListener(window, 'load', initSimpleMap);
    }

    /* -----------------------------
    * Locations Map
     ---------------------------- */
    let $locationsMap = $('.js-locations-map');

    function initLocationMap() {
        let markers = [];

        $locationsMap.each(function () {
            let currMap = $(this)[0];

            let mapData = $(currMap).data("locations");
            let mapMarker = $(currMap).data('marker');
            let numberOfLocations = $(currMap).data('location-count');

            let centerLat = $(currMap).data('location-1-latitude');
            let centerLng = $(currMap).data('location-1-longitude');

            let mapOptions = {
                zoom: 10,
                scrollwheel: false,
                center: new google.maps.LatLng(centerLat, centerLng),
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                streetViewControl: true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                styles: mapStyles
            };

            // Create the Google Map using our element and options defined above
            let map = new google.maps.Map(currMap, mapOptions);
            let i = 1;

            while (i <= numberOfLocations) {
                let locationName = $(currMap).data('location-' + i + '-title');
                let locationAddress = $(currMap).data('location-' + i + '-address');
                let locationTelephone = $(currMap).data('location-' + i + '-telephone');
                let locationUrl = $(currMap).data('location-' + i + '-url');
                let locationLat = $(currMap).data('location-' + i + '-latitude');
                let locationLng = $(currMap).data('location-' + i + '-longitude');

                // Create Info Window
                const contentString =
                    '<div class="locations-map__map__info-window">' +
                    '<h3 class="mt-0 mb-1 color-dark-gray">' + locationName + '</h3>' +
                    '<div class="text-block locations-map__map__info-window__address color-light-gray mb-2">' + locationAddress + '</div>' +
                    '<a href="tel:' + locationTelephone + '" class="locations-map__map__info-window__telephone">' + locationTelephone + '</a>' +
                    '<div class="mt-3"><a href="' + locationUrl + '" class="locations-map__map__info-window__btn">More details</a></div>' +
                    "</div>";

                let infowindow = new google.maps.InfoWindow({
                    content: contentString,
                });

                // Create Marker
                let marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locationLat, locationLng),
                    map: map,
                    icon: {
                        url: mapMarker
                    },
                    animation: google.maps.Animation.DROP
                });

                marker.addListener("click", () => {
                    infowindow.open({
                        anchor: marker,
                        map,
                        shouldFocus: false,
                    });
                });

                marker.set("officeId", i);
                markers.push(marker);
                i++;
            }
        });
    }

    if ($locationsMap.length > 0) {
        google.maps.event.addDomListener(window, 'load', initLocationMap);
    }


    /* -----------------------------
    * Login Form Toggle
     ---------------------------- */
    $('.js-login-form-toggle').click(function (e) {
        e.preventDefault();

        let target = $(this).attr('href');
        let toHide = $(this).data('to-hide');
        $(toHide).slideUp();
        $(target).slideDown();
    });

    /* ----------------------------------------
    Cart
    ---------------------------------------- */
    function updateCartItemQuantity(id, quantity) {
        jQuery.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            data: {
                updates: {
                    [id]: quantity
                }
            },
            success: function (cart) {
                location.reload();
            }
        });
    }

    $('.js-cart-quantity-input').change(function () {
        let quantity = $(this).val();
        let productId = $(this).data('product-id');

        if (quantity > 0) {
            updateCartItemQuantity(productId, quantity);
        } else {
            // Remove Product
            let productWrapper = $(this).closest('.js-cart-product');
            $(productWrapper).slideUp('500', function () {
                updateCartItemQuantity(productId, 0);
            });
        }
    });

    $('.js-cart-form-submit').click(function (e) {
        let $termsInput = $('.js-cart-terms');

        if ($termsInput.length > 0) {
            let $termsError = $('.js-terms-error');

            if ($termsInput.is(':checked')) {
                $termsError.hide();
                $(this).submit();
            } else {
                $termsError.show();
                return false;
            }
        }
    });

  	// Add notes to cart
    $('.js-cart-note').focusout(function() {
        let note = $(this).val();
        jQuery.ajax({
          url: '/cart/update.js',
          type: 'post',
          dataType: 'json',
          data: { note: note },
          success: function (cart) {
            console.log("Note added");
          }
        });
    });

    /* ----------------------------------------
    Load more blog posts
    ---------------------------------------- */
    $(document.body).on("click", ".js-load-more-cards", function (e) {
        e.preventDefault();
        let getUrl = $(this).data('page-url') + '&view=data';
        let $btn = $(this);

        $.ajax({
            url: getUrl,
            type: 'GET',
            beforeSend: function () {
                $btn.html('<span class="spinner"><svg class="w-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M296 48c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-40 376c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm248-168c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-416 0c0-22.091-17.909-40-40-40S8 233.909 8 256s17.909 40 40 40 40-17.909 40-40zm20.922-187.078c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40c0-22.092-17.909-40-40-40zm294.156 294.156c-22.091 0-40 17.909-40 40s17.909 40 40 40c22.092 0 40-17.909 40-40s-17.908-40-40-40zm-294.156 0c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z"></path></svg></span>');
            },
            success: function (data) {
                let $listingGrid = $('.js-listing-grid');

                // Set grid height to stop page jumping
                $listingGrid.css('height', $listingGrid.height());

                // Hide old btn
                $btn.slideUp('400', function() {
                    $btn.parent().remove();
                });

                // Add animate class to new items
                data = data.replace(/js-card-item/g, 'to-animate js-card-item');

                // Append new data
                $listingGrid.append(data);

                // Set new grid height to we can have nice animation
                $listingGrid.css('height', $listingGrid[0].scrollHeight);

                setTimeout(function () {
                    $listingGrid.css('height', 'auto');
                }, 300);

                // Animate in new posts
                let timer = 500;
                let newPosts = $('.to-animate.js-card-item').not('.animated');
                console.log(newPosts);

                $(newPosts).each(function () {
                    let $currPost = $(this);
                    setTimeout(function () {
                        $currPost.addClass('animated');
                    }, timer);

                    timer = timer + 150;
                });
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    /* ----------------------------------------
    Product card variant selector
    ---------------------------------------- */
    let $variantCardSelector = $('.js-product-card-variant-selector');
    let variantActiveClass = 'dropdown-item--active';
    $(document.body).on("click", ".js-product-card-variant-selector", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let $currentDropdownItem = $(this);
        let form = $(this).parents('.js-product-card-add-form');
        let variantInput = $(form).find('.js-product-card-add-form-variant');
        let variantId = $(this).data('id');
        let successClass = 'dropdown-item--success';
        let ogText = $currentDropdownItem.html();

        $(variantInput).val(variantId);

        $currentDropdownItem.addClass(variantActiveClass);
        $currentDropdownItem.siblings().removeClass(variantActiveClass);

        // Add to cart
        jQuery.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: {
                items: [
                    {
                        id: variantId,
                        quantity: 1
                    }
                ]
            },
            success: function (cart) {
                $currentDropdownItem.addClass(successClass);
                $currentDropdownItem.text('Product Added');

                updateCartPreview();

                // Remove success animation
                setTimeout(function () {
                    $currentDropdownItem.removeClass(successClass);
                    $currentDropdownItem.html(ogText);
                }, 1600);
            }
        });
    });

    $('.navigation__link--has-child').on('click', function(e) {
        if (window.outerWidth < 992) {
            e.preventDefault();
            $(this).parent().toggleClass('navigation__link--open');
        }
    });

    $(document.body).on("click", ".js-product-card-add-btn", function (e) {
       e.preventDefault();

      let formWrapper = $(this).closest('.js-product-card-add-form');
      let productId = $(formWrapper).data('productid');
      let variantId = $(formWrapper).find('.js-product-card-add-form-variant').val();
      let $btn = $(this);
      let ogText = $btn.html();
      let sellingPlanId = $(formWrapper).data('selling-plan-id');
      let product = {'id': variantId, 'quantity': 1 }

      if(sellingPlanId !== undefined && sellingPlanId != '') {
        product['selling_plan'] = sellingPlanId
      }

        jQuery.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: {
                items: [
                    product
                ]
            },
            success: function (cart) {
                $btn.text('Added');

                updateCartPreview();

                // Remove success animation
                setTimeout(function () {
                    $btn.html(ogText);
                }, 1600);
            }
        });

    });

    function updateCartPreview () {
        jQuery.ajax({
            url: '/cart.js',
            type: 'get',
            dataType: 'json',
            success: function(cart){
                // Update item counter
                let $itemCounter = $('.js-header-item-counter');
                $itemCounter.text(cart.item_count);
                let $basketPreviewHolder = $('.js-basket-preview-holder');

                $basketPreviewHolder.empty();
                let html = '';

                if(cart.items == 0) {
                    html = '<p class="m-0 h5 color-dark-gray text-center">Your cart is currently empty</p>';
                } else {
                    html = '<ul class="m-0 list-unstyled">';

                    $.each(cart.items, function(key, product) {
                        html += '<li class="header__basket-preview__item js-basket-preview-item"><a href="'+product.url+'" title="'+product.title+'" class="m-0 header__basket-preview__product-title color-dark-gray">'+product.title+'</a>';

                        if(product.quantity > 1) {
                            html += '<p class="m-0 text-sm">'+product.quantity+' x '+Shopify.formatMoney(product.final_price).replace('$','£')+' — '+Shopify.formatMoney(product.final_line_price).replace('$','£')+'</p>';
                        } else {
                            html += '<p class="m-0 text-sm">'+Shopify.formatMoney(product.final_line_price).replace('$','£')+'</p>';
                        }

                        html += '<a href="#" data-product-id="'+product.variant_id+'" class="header__basket-preview__close js-header-basket-preview-remove"><svg class="w-100" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="home-+-interactions" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="1c-home-search-mechanics" transform="translate(-1208.000000, -300.000000)"><g id="basket" transform="translate(1208.000000, 300.000000)"><circle id="Oval" stroke="currentColor" stroke-width="0.857142857" cx="15" cy="15" r="14.5714286"></circle><g id="noun_Close_996783" transform="translate(9.000000, 9.000000)" fill="currentColor" fill-rule="nonzero"><path d="M12.6487823,10.5743531 L8.57170212,6.49960977 L12.6456605,2.42252506 C13.1154925,1.95425347 13.1154925,1.20111665 12.6472214,0.731284145 L12.2687023,0.351984151 C12.0462735,0.124091973 11.7418973,0 11.4219121,0 C11.4203512,0 11.4203512,0 11.4203512,0 C11.1003659,0 10.799892,0.125652879 10.5751219,0.351203698 L6.49960259,4.42984931 L2.42252239,0.355886414 C1.95503176,-0.112385183 1.20267622,-0.114726541 0.73284424,0.353545056 L0.353544665,0.728942787 C0.124872288,0.952932701 0,1.25730924 0,1.57651438 C0,1.89728042 0.12565274,2.1993156 0.35120331,2.42408597 L4.42984442,6.49960977 L0.355105569,10.5766945 C-0.114726415,11.0449661 -0.114726415,11.7981029 0.353544665,12.2694963 L0.732063788,12.6480158 C0.956053455,12.875908 1.2596492,13 1.57963444,13 C1.89805878,13 2.20243498,12.8727862 2.42642465,12.6487963 L6.50116349,8.57093114 L10.5766828,12.6441136 C10.8076965,12.8774689 11.1151945,12.9953173 11.423473,12.9953173 C11.7286296,12.9953173 12.0345668,12.8790298 12.2679218,12.6464549 L12.646441,12.2687159 C12.8758938,12.0462868 13,11.7419103 13,11.4219247 C13.0015465,11.1019391 12.8758938,10.7999039 12.6503432,10.5743531 L12.6487823,10.5743531 Z" id="Path"></path></g></g></g></g></svg></a></li>';
                    });

                    html += '</ul><a href="/cart" class="btn btn-secondary d-block mt-2 header__basket-preview__btn"><span>View my basket</span></a>';
                }

                $basketPreviewHolder.html(html);
            }
        });
    }

      /* -----------------------------
    * Event Filtering
     ---------------------------- */
    let $showAllEventsLink = $('.js-event-category-filter-show-all');
    let $eventCategoryFilter = $('.js-event-category-filter');

    $eventCategoryFilter.change(function(e) {
       let val = $(this).val();
       let events = $('.js-event-card-item');

       if(val == 'all') {
           $showAllEventsLink.hide();
       } else {
           $showAllEventsLink.show();
       }

       $(events).each(function() {
          let currCategories =  $(this).data('event-category');

           if (currCategories.indexOf(val) >= 0) {
               $(this).show();
           } else {
               $(this).hide();
           }
       });
    });

    $showAllEventsLink.click(function(e) {
       e.preventDefault();
        $eventCategoryFilter.val('all').change();
    });

      /* -----------------------------
  * Variant Switcher
   ---------------------------- */
  // Adjust quantity selector based on inventory
  $('.js-product-variant-dropdown').change(function() {
    let inventoryNo = $(this).find('option:selected').data('inventory');
    if(inventoryNo !== undefined && inventoryNo != null) {
      let maxQuantity = 25;

      if(inventoryNo < maxQuantity) {
        maxQuantity = inventoryNo;
      }

      let $quantitySelector = $('.js-product-quantity');
      $quantitySelector.empty();

      for ( var i = 1, l = maxQuantity; i <= l; i++ ) {
          $quantitySelector.append($('<option>', {
            value: i,
            text: i
        }));
      }
    }
  });

      // Variant Options
    let variantOptionClass = '.js-variant-option';
    let $variantOptions = $(variantOptionClass);
    let $variantFieldForForm = $('.js-product-variants');

    function buildLookForString(options) {
        let optionNames = [];
        options.each(function() {
            if($(this).val() != '' && $(this).val() != null) {
                optionNames.push($(this).val());
            }
        });
        return optionNames.join("||");
    }

    $variantOptions.change(function (e) {
        e.preventDefault();

        let $currSelected = $(this);
        let stringtolookfor = buildLookForString($variantOptions);
        let selectedData = null;

        // Set the variation selector
        variantOptions.forEach(function(item) {
            if((stringtolookfor == item[0] || item[0].indexOf(stringtolookfor) >= 0 && selectedData == null) && item[2] == true) {
                selectedData = item;
            }
        });

        if(selectedData != null) {
            $variantFieldForForm.val(selectedData[1]);
        }

        // Find the next select and enable it
        if($currSelected.val() == '' || $currSelected.val() == null) {
            // Disable all after
            var toDisable = $currSelected.nextAll(variantOptionClass);
        }  else {
            // Enable next
            let nextSelectorField = $currSelected.nextAll(variantOptionClass+':first');
            var toDisable = $currSelected.nextAll(variantOptionClass).not(nextSelectorField);

            $(nextSelectorField).val('');

            // Enable/Disable to options if they're available
            let currstringtolookfor = buildLookForString($variantOptions);

            $(nextSelectorField).find('option').each(function () {
                if($(this).val() != '' && $(this).val() != null) {
                    let stringToCheck = currstringtolookfor + '||' + $(this).val();
                    let available = false;

                    variantOptions.forEach(function(item) {
                        if((stringToCheck == item[0] || item[0].indexOf(stringToCheck) >= 0) && available == false) {
                            available = item[2];
                        }
                    });

                    let updatedOptionText = $(this).val();

                    if(available == false) {
                        console.log(stringToCheck);
                        console.log($(this));

                        $(this).prop('disabled', true);

                        if($(this).is(':selected')) {
                            $(nextSelectorField).val('');
                        }

                        updatedOptionText += " - not available";

                    } else {
                        $(this).prop('disabled', false);
                    }

                    $(this).text(updatedOptionText);


                }
            });

            // Enable next
            $(nextSelectorField).prop('disabled', false);
        }

        toDisable.prop('disabled', true);
        toDisable.val('');
    });

    $('.js-evey-add-form').submit(function(e) {
       e.preventDefault();

        let quantity = $(this).find('#Quantity').val();
        let variant = $(this).find('.js-product-variants').val();
        let btn = $(this).find('#submit-btn');

        let btnText = $(btn).val();

        jQuery.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: {
                items: [
                    {
                        id: variant,
                        quantity: quantity
                    }
                ]
            },
            success: function (cart) {
                console.log(cart);

                $(btn).val('Product Added');

                updateCartPreview();

                // Remove success animation
                setTimeout(function () {
                    $(btn).val(btnText);
                    $('#success-modal').modal('show');
                }, 1600);
            }
        });
    });

    // Custom Range Slider
    let $valueSliders = $('.js-value-slider');
    if($valueSliders.length > 0) {
        $valueSliders.each(function() {
            let $currSlider = $(this);
            setSliderPosition($currSlider);

            let input = $(this).find('input');
            $(document).on('input', input, function() {
                setSliderPosition($currSlider);
            });
        });

        function setSliderPosition($sliderWrapper) {
            let input = $sliderWrapper.find('input');
            let valueHolder = $sliderWrapper.find('.js-value-slider-readout');
            let valueHolderWrapper = $(valueHolder).parent();

            let currVal = $(input).val();
            let minVal = $(input).attr('min');
            let maxVal = $(input).attr('max');

            let percentageValue = (currVal-minVal)/(maxVal-minVal)*100;

            $(valueHolderWrapper).css('left', percentageValue + '%');
            $(input).css('background', 'linear-gradient(to right, #E5E5E5 0%, #E5E5E5 ' + percentageValue + '%, #555454 ' + percentageValue + '%, #555454 100%)');


            valueHolder.text(currVal);
        }
    }

    // Copy input text to clipboard on button click
    $('.js-copy-input-text').click(function(e) {
       e.preventDefault();

       let $currBtn = $(this);

        var copyText = document.getElementById($(this).data('target'));
        copyText.select();
        copyText.setSelectionRange(0, 99999);

        navigator.clipboard.writeText(copyText.value);

        $currBtn.text('Copied');

        setTimeout(function() {
            $currBtn.text('Copy code');
        }, 2000);

    });

        /* -----------------------------
    * Notification Bar
    ---------------------------- */
  let $notificationBar = $('.js-notification-bar');
  let notificationBarCookieName = "notification-bar-hidden";

  if($notificationBar.length > 0) {
    let cookieCheck = getCookie(notificationBarCookieName);

    if(cookieCheck == null || cookieCheck == "") {
     $notificationBar.slideDown();
    }
  }

    $('.js-notification-bar-close').click(function(e) {
      e.preventDefault();
      setCookie(notificationBarCookieName, "true", 30);
      $notificationBar.slideUp();
    });

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /* -----------------------------
  * Landing Page Slick Arrows
  ---------------------------- */
  let landingPagePrevArrow = '<button type="button" class="landing-slick-arrow landing-slick-arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none"><path d="M15 6.00125H3.14L6.77 1.64125C6.93974 1.43704 7.0214 1.17375 6.99702 0.909329C6.97264 0.644902 6.84422 0.400991 6.64 0.231252C6.43578 0.0615137 6.1725 -0.0201482 5.90808 0.0042315C5.64365 0.0286112 5.39974 0.157036 5.23 0.361252L0.23 6.36125C0.195676 6.40853 0.165561 6.45872 0.14 6.51125C0.14 6.56125 0.14 6.59125 0.0700002 6.64125C0.0246737 6.75591 0.000941121 6.87796 0 7.00125C0.000941121 7.12454 0.0246737 7.24659 0.0700002 7.36125C0.0700002 7.41125 0.0699999 7.44125 0.14 7.49125C0.165561 7.54379 0.195676 7.59398 0.23 7.64125L5.23 13.6413C5.32402 13.7541 5.44176 13.8449 5.57485 13.9071C5.70793 13.9694 5.85309 14.0015 6 14.0013C6.23365 14.0017 6.46009 13.9203 6.64 13.7713C6.74126 13.6873 6.82496 13.5842 6.88631 13.4679C6.94766 13.3515 6.98546 13.2242 6.99754 13.0932C7.00961 12.9622 6.99573 12.8302 6.95669 12.7046C6.91764 12.579 6.8542 12.4623 6.77 12.3613L3.14 8.00125H15C15.2652 8.00125 15.5196 7.8959 15.7071 7.70836C15.8946 7.52082 16 7.26647 16 7.00125C16 6.73604 15.8946 6.48168 15.7071 6.29415C15.5196 6.10661 15.2652 6.00125 15 6.00125Z" fill="currentColor"/></svg><span class="d-none">Previous</span></button>';
  let landingPageNextArrow = '<button type="button" class="landing-slick-arrow landing-slick-arrow--next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none"><path d="M1 8L12.86 8L9.23 12.36C9.06026 12.5642 8.9786 12.8275 9.00298 13.0919C9.02736 13.3563 9.15578 13.6003 9.36 13.77C9.56422 13.9397 9.8275 14.0214 10.0919 13.997C10.3563 13.9726 10.6003 13.8442 10.77 13.64L15.77 7.64C15.8043 7.59272 15.8344 7.54253 15.86 7.49C15.86 7.44 15.86 7.41 15.93 7.36C15.9753 7.24534 15.9991 7.12329 16 7C15.9991 6.87671 15.9753 6.75466 15.93 6.64C15.93 6.59 15.93 6.56 15.86 6.51C15.8344 6.45747 15.8043 6.40727 15.77 6.36L10.77 0.36C10.676 0.247117 10.5582 0.156337 10.4252 0.0941153C10.2921 0.0318937 10.1469 -0.000239372 10 -9.53674e-07C9.76635 -0.000457764 9.53991 0.0809174 9.36 0.229999C9.25874 0.313948 9.17504 0.417049 9.11369 0.533397C9.05234 0.649744 9.01454 0.77705 9.00246 0.908027C8.99039 1.039 9.00427 1.17108 9.04331 1.29668C9.08236 1.42228 9.1458 1.53895 9.23 1.64L12.86 6L1 6C0.734783 6 0.480429 6.10536 0.292892 6.29289C0.105356 6.48043 0 6.73478 0 7C0 7.26522 0.105356 7.51957 0.292892 7.70711C0.480429 7.89464 0.734783 8 1 8Z" fill="currentColor"/></svg><span class="d-none">Next</span></button>';

  /* -----------------------------
  * Gallery Block
  ---------------------------- */
  let $gallerySlider = $('.js-gallery-slider');
  if($gallerySlider.length > 0) {
    $gallerySlider.each(function() {
      let $currSlider = $(this);
      let nav = $currSlider.closest('section').find('.js-gallery-slider-nav');

      console.log($(this).attr('class'), $(this).children().length);

      $currSlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        mobileFirst: true,
        dots: true,
        appendDots: $(nav),
        appendArrows: $(nav),
        prevArrow: landingPagePrevArrow,
        nextArrow: landingPageNextArrow,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              rows: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              rows: 2,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      });

    });
  }

  $('.js-gallery-modal-trigger').click(function(e) {
    e.preventDefault();

    let targetModal = $(this).data('modal');
    let imgUrl = $(this).data('img-url');
    let imgHolder = $(targetModal).find('.js-gallery-image-holder');
    let imgElement = '<img src="'+imgUrl+'" class="img-fluid"/>';

    $(imgHolder).html(imgElement);
    $(targetModal).modal('show');
  });

  /* -----------------------------
  * Hero Slider Block
  ---------------------------- */
  let $heroImgSlider = $('.js-hero-slider-images');
  if($heroImgSlider.length > 0) {
    $heroImgSlider.each(function(e) {
      let $currSlider = $(this);
      let wrapper = $currSlider.closest('.js-hero-slider-wrapper');
      let nav = $(wrapper).find('.js-hero-slider-nav');
      let counter = $(wrapper).find('.js-hero-slider-counter');

      $currSlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        appendArrows: $(nav),
        appendDots: $(nav),
        prevArrow: landingPagePrevArrow,
        nextArrow: landingPageNextArrow
      });

      $currSlider.on('afterChange', function(event, slick, currentSlide){
        $(counter).text(currentSlide + 1);
      });
    });
  }

  /* -----------------------------
  * Booking Widget
  ---------------------------- */
  let bookingWidgetInputClass = '.js-booking-widget-input';
  let wrapperClass = '.js-booking-widget';

  $(bookingWidgetInputClass).on('change', function() {
    let wrapper = $(this).closest(wrapperClass);
    let totalHolder = $(wrapper).find('.js-booking-widget-price');
    let inputs = $(wrapper).find(bookingWidgetInputClass);
    let totalCount = 0;

    inputs.each(function() {
      let currPrice = $(this).data('price');
      totalCount += currPrice * $(this).val();
    });

    $(totalHolder).text(Shopify.formatMoney(totalCount).replace('$','£'));
  });

  $('.js-booking-widget-form').submit(function(e) {
    e.preventDefault();

    let wrapper = $(this).closest(wrapperClass);
    let msg = '';
    let error = false;
    let inputs = $(wrapper).find(bookingWidgetInputClass);
    let items = [];
    let errorWrapper = $(wrapper).find('.js-booking-widget-error');

    inputs.each(function() {
      let quantity = $(this).val();
      let id = $(this).data('variant');

      if (quantity > 0) {
        items.push({
          id: id,
          quantity: quantity
        });
      }
    });

    if(items.length <= 0) {
      msg = 'Add some tickets to book this event';
      error = true;
    }

    if(error == false) {
      $(errorWrapper).slideUp();

      jQuery.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: {
          items: items
        },
        before: function () {
          $(wrapper).addClass('loading');
        },
        success: function (cart) {
          $(wrapper).removeClass('loading');

          updateCartPreview();

          // Add Success Message
          let succssMsg = $(wrapper).find('.js-success-msg');
          $(succssMsg).fadeIn();

          // Remove success animation
          setTimeout(function () {
            $(succssMsg).fadeOut();
          }, 2200);
        }
      });
    } else {

      $(errorWrapper).find('span').text(msg);
      $(errorWrapper).slideDown();
    }
  });

  let $bookingWidgetFooter = $('.js-booking-widget-sticky-footer');
  if($bookingWidgetFooter.length > 0) {

    $bookingWidgetFooter.each(function() {
      let $currWidget = $(this);
      let $target = $($(this).data('related-widget'));

      const widgetObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          $currWidget.toggleClass('hidden', entry.isIntersecting);
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      widgetObserver.observe($target[0]);
    });
  }

});



